// extracted by mini-css-extract-plugin
export var legendIndicator = "_c3-1";
export var legendRight = "_c3-0";